import {
  apiClientForCourses,
  baseForPdf,
  schoolApiClient,
} from '../apiClients';
import { Endpoints } from '../../network';

export const getAuthorProfile = async (userName: string) => {
  const response = await baseForPdf.get(
    `${Endpoints.authorProfile}/${userName}`,
  );
  return response?.data;
};

export interface IAuthorDetails {
  _id: string;
  name: string;
  email?: string;
  zl_uid: string;
  designation: string[];
  avatar?: string;
  description: string[];
  longDescription: string;
  meta: {
    [key: string]: string;
  };
  user_name?: string;
  learners?: string;
  backgroundImage?: string;
  bio?: string;
  isBestSellingAuthor?: boolean;
  followers: string[];
  linkedinLink?: string;
  bookacallLink?: string;
  isVerified?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

export const getAuthorProfileV2 = async (id: string) => {
  const response = await baseForPdf.get(`${Endpoints.authorProfileV2}/${id}`);
  return response?.data;
};

export const followAuthorV2 = async (id: string) => {
  const response = await baseForPdf.post(
    `${Endpoints.authorProfileV2}/${id}/follow`,
  );
  return response?.data;
};

export const getFeaturedAuthors = async () => {
  const response = await schoolApiClient.get(`${Endpoints.featuredProfile}`);
  return response?.data;
};

export const getallAuthorBooks = async (limit: number, authorId: string) => {
  const urlWithQuery = `${Endpoints.getAuthorBooks}?limit=${limit}&author=${authorId}`;
  const response = await baseForPdf.get(urlWithQuery);
  return response?.data;
};

export const getallAuthorCourses = async (limit: number, authorId: string) => {
  const urlWithQuery = `${Endpoints.getAuthorCourses}?limit=${limit}&author=${authorId}`;
  const response = await apiClientForCourses.get(urlWithQuery);
  return response?.data;
};

export const getallAuthorSchools = async (authorId: string) => {
  const urlWithQuery = `${Endpoints.authorSchools}/author_id:${authorId}`;
  const response = await schoolApiClient.get(urlWithQuery);
  return response?.data;
};

export const getallAuthorLive = async (authorId: string) => {
  const urlWithQuery = `${Endpoints.authorLive}/${authorId}`;
  const response = await schoolApiClient.get(urlWithQuery);
  return response?.data;
};
